'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _plugin = require('../../plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _timeDeltaHelper = require('../../helpers/timeDeltaHelper');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var ChatParser = function (_Plugin) {
  _inherits(ChatParser, _Plugin);
  function ChatParser() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, ChatParser);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatParser.__proto__ || Object.getPrototypeOf(ChatParser)).call.apply(_ref, [this].concat(args))), _this), _this.normalizeField = function (fieldName, value) {
      // snake-case to camelCase
      var key = fieldName.replace(/(_\w)/g, function (part) {
        return part[1].toUpperCase();
      });

      // Change the type of same keys
      var valueNormalized = void 0;
      var keepOriginalValue = false;
      switch (key) {
        case 'seen':
          valueNormalized = !!Number(value);
          break;
        case 'buyerId':
        case 'sellerId':
        case 'username':
          valueNormalized = String(value);
          break;
        case 'createdAt':
        case 'lastMessageAt':
        case 'lastSeenAt':
          keepOriginalValue = true;
          valueNormalized = (0, _timeDeltaHelper.applyTimestampDeltaToDate)(value, _this.entity.timestampDelta);
          break;
        default:
          valueNormalized = value;
          break;
      }
      var result = _defineProperty({}, key, valueNormalized);
      if (keepOriginalValue) {
        var capitalizedKey = capitalizeFirstLetter(key);
        result['original' + capitalizedKey] = value;
      }
      return result;
    }, _this.parse = function (chats) {
      return chats.map(function (chat) {
        return Object.entries(chat.attrs).reduce(function (acc, _ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];
          return _extends({}, _this.normalizeField(key, value), acc);
        }, {});
      });
    }, _this.extract = function (stanza) {
      if (stanza) {
        var chats = stanza.getChild('chats');
        if (chats) {
          return _this.parse(chats.getChildren('chat'));
        }
        var chat = stanza.getChildren('chat');
        if (chat.length) {
          return _this.parse(chat);
        }
      }
      return [];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  return ChatParser;
}(_plugin2.default);
ChatParser.pluginName = 'chatParser';
exports.default = ChatParser;